import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";

class FirebaseManager {
  constructor() {
    const firebaseConfig = {
      apiKey: "AIzaSyA8BROVCbdwCmQN68yg2ghacm5g_NQk6HQ",
      authDomain: "dent-develop.firebaseapp.com",
      databaseURL: "https://dent-develop.firebaseio.com",
      projectId: "dent-develop",
      storageBucket: "dent-develop.appspot.com",
      messagingSenderId: "1080349496667",
      appId: "1:1080349496667:web:153ad899c0bd0717aaf67e",
      measurementId: "G-SVTLKY0NQC",
    };

    firebase.initializeApp(firebaseConfig);
  }

  createUser(
    email,
    password,
    phoneNumber,
    firstName,
    lastname,
    callbackSuccess,
    callbackFail
  ) {
    firebase
      .auth()
      .createUserWithEmailAndPassword(email, password)
      .then((data) => {
        firebase
          .firestore()
          .collection("users")
          .doc(data.user.uid)
          .set({
            name: `${phoneNumber} ${firstName}`,
            phoneNumber: lastname,
            email: email,
            user_type: "Consumer",
          });
        callbackSuccess();
      })
      .catch((err) => {
        callbackFail(err.message);
      });
  }

  loginUser(email, password, callbackSuccess, callbackFail) {
    firebase
      .auth()
      .signInWithEmailAndPassword(email, password)
      .then((u) => {
        callbackSuccess();
      })
      .catch((err) => {
        callbackFail(err.message);
      });
  }
  loginWithProvider(provider, callbackSuccess, callbackFail) {
    firebase
      .auth()
      .signInWithPopup(provider)
      .then(function (result) {
        let userId = firebase
          .firestore()
          .collection("users")
          .doc(result.user.uid);
        userId.get().then((user) => {
          if (!user.exists) {
            firebase.firestore().collection("users").doc(result.user.uid).set({
              email: result.user.email,
              user_type: "Consumer",
              name: result.user.displayName,
              phoneNumber: "",
              address: "",
            });
          }
        });
        callbackSuccess();
      })
      .catch(function (error) {
        callbackFail(error.message);
      });
  }

  loginWithProviderTechnician(provider, callbackSuccess, callbackFail) {
    firebase
      .auth()
      .signInWithPopup(provider)
      .then(function (result) {
        let userId = firebase
          .firestore()
          .collection("users")
          .doc(result.user.uid);
        userId.get().then((user) => {
          if (!user.exists) {
            firebase.firestore().collection("users").doc(result.user.uid).set({
              email: result.user.email,
              user_type: "Technician",
              name: result.user.displayName,
              phoneNumber: "",
              address: "",
            });
          }
        });
        callbackSuccess();
      })
      .catch(function (error) {
        callbackFail(error.message);
      });
  }

  loginUserWithFacebook(callbackSuccess, callbackFail) {
    var provider = new firebase.auth.FacebookAuthProvider();
    this.loginWithProvider(provider, callbackSuccess, callbackFail);
  }

  loginUserWithGmail(callbackSuccess, callbackFail) {
    var provider = new firebase.auth.GoogleAuthProvider();
    this.loginWithProvider(provider, callbackSuccess, callbackFail);
  }

  loginUserWithGmailTechnician(callbackSuccess, callbackFail) {
    var provider = new firebase.auth.GoogleAuthProvider();
    this.loginWithProviderTechnician(provider, callbackSuccess, callbackFail);
  }

  loginUserWithFacebookTechnician(callbackSuccess, callbackFail) {
    var provider = new firebase.auth.FacebookAuthProvider();
    this.loginWithProviderTechnician(provider, callbackSuccess, callbackFail);
  }

  createUserTechnician(
    email,
    password,
    firstName,
    lastname,
    address,
    phoneNumber,
    callbackSuccess,
    callbackFail
  ) {
    firebase
      .auth()
      .createUserWithEmailAndPassword(email, password)
      .then((data) => {
        firebase
          .firestore()
          .collection("users")
          .doc(data.user.uid)
          .set({
            name: `${firstName} ${lastname}`,
            address: address,
            email: email,
            phone: phoneNumber,
            user_type: "Technician",
          });
        callbackSuccess();
      })
      .catch((err) => {
        callbackFail(err.message);
      });
  }

  loginUserTechnician(email, password, callbackSuccess, callbackFail) {
    firebase
      .auth()
      .signInWithEmailAndPassword(email, password)
      .then((u) => {
        callbackSuccess();
      })
      .catch((err) => {
        callbackFail(err.message);
      });
  }

  loginAdmin(email, password, callbackSuccess, callbackFail) {
    firebase
      .auth()
      .signInWithEmailAndPassword(email, password)
      .then((u) => {
        callbackSuccess();
      })
      .catch((err) => {
        callbackFail(err.message);
      });
  }

  showInfoDent(successCallback, failCallback) {
    var docRef = firebase
      .firestore()
      .collection("dent_info")
      .doc(sessionStorage.getItem("new_dent_id"));
    docRef
      .get()
      .then(function (doc) {
        successCallback(doc.data());
      })
      .catch(function (error) {
        failCallback(error);
      });
  }
  showAllDent() {
    let datos = document.getElementById("datos");
    firebase
      .firestore()
      .collection("dent_info")
      .onSnapshot((querySnapshot) => {
        datos.innerHTML = "";
        querySnapshot.forEach((doc) => {
          if (doc.data().status === "technician") {
            let noJobAvailable = document.getElementById("noJobsAvailable");
            noJobAvailable.classList.add("d-none");
            let dentAvailable = document.getElementById("dentAvailable");
            dentAvailable.classList.remove("d-none");
            datos.innerHTML += `
                <button class="btnNull d-block mx-auto" onclick="sessionStorage.setItem('ID','${
                  doc.id
                }')">
                <div class="mx-auto mt-3 mb-3">
                <div class="container card-detail mt-3 mb-3">
                
                    <table class="table table-borderless table_color">
                    <tbody>
                      <tr>
                        <td><b>Price:</b></td>
                        <td class="color_blue">${doc.data().price || "Price to be confirmed"}</td>
                      </tr>
                      <tr>                          
                      <td><b>Appointment time:</b></td>
                      <td class="color_blue">${
                        doc.data().SelectedTimeRepair || "To be confirm"
                      }</td>
                      </tr>
                      <tr>
                        
                        <td><b>Make:</b>:</td>
                        <td>${doc.data().car_brand}</td>
                       
                      </tr>
                      <tr>
                        <td><b>Model:</b>:</td>
                        <td>${doc.data().car_model}</td>
                      </tr>
                      <tr>
                      <td><b>Year:</b></td>
                      <td>${doc.data().car_model}</td>
                    </tr>
                      <tr>                          
                      <td><b>Dent:</b></td>
                      <td>${doc.data().dent_place}</td>
                    </tr>
                    <tr>                          
                      <td><b>Address:</b></td>
                      <td>${doc.data().info_location}</td>
                    </tr>
                    <tr>                          
                      <td><b>Requested times:</b></td>
                      <td>${doc.data().info_time}</td>
                    </tr>
                    </tbody>
                  </table>
              
                <div class="text-center mt-4 pb-4">
                    <div class="row justify-content-between ml-3 mr-3">
                        <div class="col-xs-4 mb-1">
                        <img src="${
                          doc.data().img1
                        }" alt="imagen" class="mx-auto sizeImg"/>
                        </div>
                        <div class="col-xs-4 mb-1">
                            <img src="${
                              doc.data().img2
                            }" alt="imagen" class="mx-auto sizeImg"/>
                        </div>
                        <div class="col-xs-4 mb-1">
                            <img src="${
                              doc.data().img3
                            }" alt="imagen" class="mx-auto sizeImg" />
                        </div>
                    </div>
                </div>
                </div>
                </div>
                </button>
                `;
          }
        });
      });
  }

  getDentInfoForCurrentUser(callback) {
    firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        let currentUserCollection = firebase
          .firestore()
          .collection("users")
          .doc(user.uid);
        currentUserCollection.onSnapshot((user) => {
          if (user.exists) {
            callback(user.data().dents);
          }
        });
      }
    });
  }

  getDentInfoForCard(dentId, callback) {
    let dentInfoCollection = firebase
      .firestore()
      .collection("dent_info")
      .doc(dentId);
    dentInfoCollection.onSnapshot((dent) => {
      if (dent.exists) {
        callback(dent.data());
      }
    });
  }

  getUserInfoForId(callback) {
    let dentInfoCollection = firebase.firestore().collection("users").doc();
    dentInfoCollection.onSnapshot((dent) => {
      if (dent.exists) {
        callback(dent.data());
      }
    });
  }

  getInfoForCurrentTechnician(callback) {
    firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        let currentUserCollection = firebase
          .firestore()
          .collection("users")
          .doc(user.uid);
        currentUserCollection.onSnapshot((user) => {
          if (user.exists) {
            callback(user.data());
          }
        });
      }
    });
  }

  updateInfoCurrentUser(
    fullName,
    address,
    phoneNumber,
    successCallback,
    failCallback
  ) {
    firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        let currentUserCollection = firebase
          .firestore()
          .collection("users")
          .doc(user.uid);
        return currentUserCollection
          .update({
            name: fullName,
            phoneNumber: phoneNumber,
            address: address,
          })
          .then(function () {
            successCallback();
          })
          .catch(function (error) {
            failCallback(error.message);
          });
      }
    });
  }

  dentSelected(successCallback, failCallback) {
    var docRef = firebase
      .firestore()
      .collection("dent_info")
      .doc(sessionStorage.getItem("ID"));
    docRef
      .get()
      .then(function (doc) {
          successCallback(doc.data())
      })
      .catch(function (error) {
        failCallback(error.message)
      });
  }

  confirmDentSelected(successCallback, failCallback) {
    firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        let currentUserCollection = firebase
          .firestore()
          .collection("users")
          .doc(user.uid);
        return currentUserCollection
          .update({
            dents: firebase.firestore.FieldValue.arrayUnion(
              sessionStorage.getItem("ID")
            ),
          })
          .then(function () {
            successCallback();

            let currentDentCollection = firebase
              .firestore()
              .collection("dent_info")
              .doc(sessionStorage.getItem("ID"));
            return currentDentCollection.update({
              SelectedTimeRepair: firebase.firestore.FieldValue.arrayUnion(
                sessionStorage.getItem("timeSelect")
              ),
              status: "payment",
              creationDate: new Date().getTime(),
            });
          })
          .catch(function (error) {
            failCallback(error);
          });
      }
    });
  }

  chargeFinalDent(selectedDays) {
    let car_brand = sessionStorage.getItem("car_brand");
    let car_model = sessionStorage.getItem("car_model");
    let car_year = sessionStorage.getItem("car_year");
    let dent_place = sessionStorage.getItem("dent_place");
    let info_location = sessionStorage.getItem("info_address");
    let notes = sessionStorage.getItem("additional_notes");
    let addtional_info_location = sessionStorage.getItem(
      "info_additional_location"
    );
    let img1 = sessionStorage.getItem("img1");
    let img2 = sessionStorage.getItem("img2");
    let img3 = sessionStorage.getItem("img3");

    firebase
      .firestore()
      .collection("dent_info")
      .add({
        car_brand: car_brand,
        car_model: car_model,
        car_year: car_year,
        dent_place: dent_place,
        info_location: info_location,
        info_time: selectedDays,
        img1: img1,
        img2: img2,
        img3: img3,
        status: "budget",
        price: "",
        notes: notes,
        additional_info_location: addtional_info_location,
        startCalification: "",
        comments: "",
      })
      .then(function (document) {
        firebase.auth().onAuthStateChanged(function (user) {
          if (user) {
            firebase
              .firestore()
              .collection("users")
              .doc(user.uid)
              .update({
                dents: firebase.firestore.FieldValue.arrayUnion(document.id)
              });
            firebase
              .firestore()
              .collection("dent_info")
              .doc(document.id)
              .update({
                dent_id: document.id,
                email: user.email
              });
            sessionStorage.clear();
            sessionStorage.setItem("new_dent_id", document.id);
            window.location = "/finding_a_denter";
          }
        });
      })
      .catch((err) => {
        alert(err.message);
      });
  }

  saveImage(file, successCallback, failCallback) {
    const storageRef = firebase.storage().ref(`images/${file.name}`);
    const task = storageRef.put(file);

    task.on(
      "state_changed",
      (snapshot) => {},
      (error) => {
        failCallback(error);
      },
      () => {
        firebase
          .storage()
          .ref("images")
          .child(file.name)
          .getDownloadURL()
          .then((url) => {
            successCallback(url);
          });
      }
    );
  }

  rejectDent(successCallback, failCallback) {
    firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        let currentUserCollection = firebase
          .firestore()
          .collection("dent_info")
          .doc(sessionStorage.getItem("idCard"));
        currentUserCollection
          .update({
            status: "rejected",
          })
          .then(function () {
            successCallback();
          })
          .catch(function (error) {
            failCallback(error.message);
          });
      }
    });
  }

  updateStatusDent(successCallback, failCallback, dentId) {
    firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        let currentUserCollection = firebase
          .firestore()
          .collection("dent_info")
          .doc(dentId);
        currentUserCollection
          .update({
            status: "expired",
            SelectedTimeRepair: "",
          })
          .then(function () {
            successCallback();
          })
          .catch(function (error) {
            failCallback(error.message);
          });
      }
    });
  }

  showDentPriceless() {
    let dentInfo = document.getElementById("dentInfo");
    firebase
      .firestore()
      .collection("dent_info")
      .onSnapshot((querySnapshot) => {
        dentInfo.innerHTML = "";
        querySnapshot.forEach((doc) => {
          if (doc.data().price === "") {
            let noData = document.getElementById("noData");
            noData.classList.add("d-none");

            let okData = document.getElementById("okData");
            okData.classList.remove("d-none");

            dentInfo.innerHTML += `
                <button class="btnNull d-block mx-auto" onclick="sessionStorage.setItem('dentId','${
                  doc.id
                }')">
                <div class="mx-auto mt-3 mb-3">
                <div class="container card-detail mt-3 mb-3">
                
                    <table class="table table-borderless table_color">
                    <tbody>
                      <tr>
                        <td><b>Price:</b></td>
                        <td class="color_blue">${doc.data().price || "Price to be confirmed"}</td>
                      </tr>
                      <tr>                          
                      <td><b>Appointment time:</b></td>
                      <td class="color_blue">${
                        doc.data().SelectedTimeRepair || "To be confirm"
                      }</td>
                      </tr>
                      <tr>
                        
                        <td><b>Make:</b>:</td>
                        <td>${doc.data().car_brand}</td>
                       
                      </tr>
                      <tr>
                        <td><b>Model:</b>:</td>
                        <td>${doc.data().car_model}</td>
                      </tr>
                      <tr>
                      <td><b>Year:</b></td>
                      <td>${doc.data().car_year}</td>
                    </tr>
                      <tr>                          
                      <td><b>Dent:</b></td>
                      <td>${doc.data().dent_place}</td>
                    </tr>
                    <tr>                          
                      <td><b>Address:</b></td>
                      <td>${doc.data().info_location}</td>
                    </tr>
                    <tr>                          
                      <td><b>Requested times:</b></td>
                      <td>${doc.data().info_time}</td>
                    </tr>
                    </tbody>
                  </table>
              
                <div class="text-center mt-4 pb-4">
                    <div class="row justify-content-between ml-3 mr-3">
                        <div class="col-xs-4 mb-1">
                        <img src="${
                          doc.data().img1
                        }" alt="imagen" class="mx-auto sizeImg"/>
                        </div>
                        <div class="col-xs-4 mb-1">
                            <img src="${
                              doc.data().img2
                            }" alt="imagen" class="mx-auto sizeImg"/>
                        </div>
                        <div class="col-xs-4 mb-1">
                            <img src="${
                              doc.data().img3
                            }" alt="imagen" class="mx-auto sizeImg" />
                        </div>
                    </div>
                </div>
                </div>
                </div>
                </button>
                `;
          }
        });
      });
  }

  showAllDentsAdmin() {
    let dentInfo = document.getElementById("allDent");
    firebase
      .firestore()
      .collection("dent_info")
      .onSnapshot((querySnapshot) => {
        dentInfo.innerHTML = "";
        querySnapshot.forEach((doc) => {
          if (doc.data().price !== "") {
            dentInfo.innerHTML += `
            <button class="btnNull mx-auto d-block" onclick="sessionStorage.setItem('dentId','${
              doc.id
            }')">
            <div class="d-flex mx-auto box-p">
              <div class="text-left mb-3 pt-3 pl-4">
              <p><b>${doc.data().car_brand} ${doc.data().car_model}</b></p>
              <p>${doc.data().dent_place}</p>
              <p><b>${doc.data().status}</b></p>
              </div>
            </div>
          </button>
                `;
          }
        });
      });
  }

  dentSelect() {
    var docRef = firebase
      .firestore()
      .collection("dent_info")
      .doc(sessionStorage.getItem("dentId"));
    let dentSelect = document.getElementById("dentSelect");
    docRef
      .get()
      .then(function (doc) {
        if (doc.exists) {
          dentSelect.innerHTML = `
          <div class="mx-auto mt-3 mb-3">
          <div class="container card-detail mt-3 mb-3">
          
              <table class="table table-borderless table_color">
              <tbody>
                <tr>
                  <td><b>Price:</b></td>
                  <td class="color_blue">${doc.data().price || "Price to be confirmed"}</td>
                </tr>
                <tr>                          
                <td><b>Appointment time:</b></td>
                <td class="color_blue">${
                  doc.data().SelectedTimeRepair || "To be confirm"
                }</td>
                </tr>
                <tr>
                  
                  <td><b>Make:</b>:</td>
                  <td>${doc.data().car_brand}</td>
                 
                </tr>
                <tr>
                  <td><b>Model:</b>:</td>
                  <td>${doc.data().car_model}</td>
                </tr>
                <tr>
                <td><b>Year:</b></td>
                <td>${doc.data().car_model}</td>
              </tr>
                <tr>                          
                <td><b>Dent:</b></td>
                <td>${doc.data().dent_place}</td>
              </tr>
              <tr>                          
                <td><b>Address:</b></td>
                <td>${doc.data().info_location}</td>
              </tr>
              <tr>                          
                <td><b>Requested times:</b></td>
                <td>${doc.data().info_time}</td>
              </tr>
              </tbody>
            </table>
        
          <div class="text-center mt-4 pb-4">
              <div class="row justify-content-between ml-3 mr-3">
                  <div class="col-xs-4 mb-1">
                  <img src="${
                    doc.data().img1
                  }" alt="imagen" class="mx-auto sizeImg"/>
                  </div>
                  <div class="col-xs-4 mb-1">
                      <img src="${
                        doc.data().img2
                      }" alt="imagen" class="mx-auto sizeImg"/>
                  </div>
                  <div class="col-xs-4 mb-1">
                      <img src="${
                        doc.data().img3
                      }" alt="imagen" class="mx-auto sizeImg" />
                  </div>
              </div>
          </div>
          </div>
          </div>
                `;
        } else {
          // doc.data() will be undefined in this case
          console.log("No such document!");
        }
      })
      .catch(function (error) {
        console.log("Error getting document:", error);
      });
  }

  confirmPriceDentSelected(successCallback, failCallback) {
    firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        let currentDentCollection = firebase
          .firestore()
          .collection("dent_info")
          .doc(sessionStorage.getItem("dentId"));
        return currentDentCollection
          .update({
            price: sessionStorage.getItem("dentPrice"),
            status: "acceptance",
          })
          .then(function (doc) {
            firebase.firestore().collection('mail').add({
              to: 'rlopez4489@gmail.com',
              message: {
                subject: 'Your received estimation!',
                html: `Hi ${user.displayName}, your received estimation.`,
              },
            })
            successCallback();
          })
          .catch(function (error) {
            failCallback(error.message);
          });
      }
    });
  }

  confirmDent(successCallback, failCallback) {
    firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        let currentUserCollection = firebase
          .firestore()
          .collection("dent_info")
          .doc(sessionStorage.getItem("idCard"));
        currentUserCollection
          .update({
            status: "technician",
          })
          .then(function () {
            successCallback();
          })
          .catch(function (error) {
            failCallback(error.message);
          });
      }
    });
  }

  confirmPaymentDent() {
    firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        let currentDentCollection = firebase
          .firestore()
          .collection("dent_info")
          .doc(sessionStorage.getItem("idCard"));
        return currentDentCollection
          .update({
            status: "confirmed",
          })
          .then(function () {
            window.location = "/home";
          })
          .catch(function (error) {});
      }
    });
  }

  confirmStartJob(successCallback, failCallback) {
    firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        let currentDentCollection = firebase
          .firestore()
          .collection("dent_info")
          .doc(sessionStorage.getItem("idCard"));
        return currentDentCollection
          .update({
            status: "progress",
          })
          .then(function () {
            successCallback();
          })
          .catch(function (error) {
            failCallback(error.message);
          });
      }
    });
  }

  dentInProgress(successCallback) {
    firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        let currentDentCollection = firebase
          .firestore()
          .collection("dent_info")
          .doc(sessionStorage.getItem("idCard"));
        return currentDentCollection
          .get()
          .then(function (doc) {
            successCallback(doc.data());
          })
          .catch(function (error) {
            alert(error);
          });
      }
    });
  }

  completeJob(successCallback, failCallback) {
    firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        let currentDentCollection = firebase
          .firestore()
          .collection("dent_info")
          .doc(sessionStorage.getItem("idCard"));
        return currentDentCollection
          .update({
            status: "fixed",
            id_technician: user.uid,
          })
          .then(function () {
            successCallback();
          })
          .catch(function (error) {
            failCallback(error.message);
          });
      }
    });
  }

  listOfReasons(reasons, successCallback, failCallback) {
    firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        let currentDentCollection = firebase
          .firestore()
          .collection("dent_info")
          .doc(sessionStorage.getItem("idCard"));
        return currentDentCollection
          .update({
            reasons: reasons,
            status: "nfix",
            id_technician: user.uid,
          })
          .then(function () {
            successCallback();
          })
          .catch(function (error) {
            failCallback(error.message);
          });
      }
    });
  }

  currentIdTechnician(callback) {
    firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        firebase
          .firestore()
          .collection("dent_info")
          .doc(sessionStorage.getItem("idCard"))
          .get()
          .then(function (doc) {
            let id_technician = doc.data().id_technician;
            let currentUserCollection = firebase
              .firestore()
              .collection("users")
              .doc(id_technician);
            currentUserCollection
              .get()
              .then(function (doc) {
                callback(doc.data());
              })
              .catch(function (error) {
                alert(error);
              });
          })
          .catch(function (error) {
            alert(error);
          });
      }
    });
  }

  commentsConsumer(comments, successCallback, failCallback) {
    firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        let currentDentCollection = firebase
          .firestore()
          .collection("dent_info")
          .doc(sessionStorage.getItem("idCard"));
        return currentDentCollection
          .update({
            comments: comments,
            startCalification: sessionStorage.getItem("ratingValue"),
          })
          .then(function () {
            successCallback();
          })
          .catch(function (error) {
            failCallback(error.message);
          });
      }
    });
  }

  confirmTime(selectedDays, successCallback, failCallback) {
    firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        let currentDentCollection = firebase
          .firestore()
          .collection("dent_info")
          .doc(sessionStorage.getItem("idCard"));
        return currentDentCollection
          .update({
            info_time: selectedDays,
            status: "technician",
          })
          .then(function () {
            successCallback();
          })
          .catch(function (error) {
            failCallback(error);
          });
      }
    });
  }

  dataTechnician(successCallback, failCallback) {
    firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        let currentUserCollection = firebase
          .firestore()
          .collection("users")
          .doc(user.uid);
        currentUserCollection
          .get()
          .then(function (doc) {
            successCallback(doc.data());
          })
          .catch(function (error) {
            failCallback(error);
          });
      }
    });
  }

 
}

const firebaseManager = new FirebaseManager();
Object.freeze(firebaseManager);

export default firebaseManager;
